const isConditionDots = (value: string) =>
	value.split('').filter((elem: string) => elem === '.').length === 1 && value.split('').slice(-1)[0] === '.';

export default isConditionDots;
